"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
interface GalleryImage {
  src: string;
  alt: string;
  caption: string;
}
const galleryImages: GalleryImage[] = [{
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0871-scaled.jpg?v=8uqs9g98a0b",
  alt: "Ruhiger, minimalistischer Behandlungsraum mit Naturleinen, Steinen und getrocknetem Lavendel",
  caption: "Achtsam gestalteter Behandlungsraum für Ruhe und Rückzug"
}, {
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0941-scaled.jpg?v=cy0a9qp38o9",
  alt: "Friedliches Lavendelfeld in der sanften Morgensonne mit Blick auf Schweizer Hügel",
  caption: "Die beruhigende Kraft der Schweizer Natur und Lavendellandschaften"
}, {
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0910-scaled.jpg?v=kltq69l6rh",
  alt: "Nahaufnahme von ruhenden Händen auf einem weichen Tuch neben einer Kerze und Lavendelblüten",
  caption: "Sanfte Berührung und energetische Zentrierung in jeder Behandlung"
}];
export default function ChakraGalerie() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="chakragalerie" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border/40 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center space-y-4 mb-12 md:mb-16">
          <div>
            <Badge variant="secondary" className="text-secondary-foreground font-normal tracking-wide">
              Atmosphäre &amp; Raum
            </Badge>
          </div>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[40px] font-normal leading-tight text-foreground text-balance">Momente der Ruhe in Zürich</h2>

          
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {galleryImages.map((image, index) => <motion.div key={image.src} variants={itemVariants} data-index={index} className="group relative overflow-hidden rounded-xl border border-border/70 bg-card shadow-xs transition-shadow duration-300 hover:shadow-md">
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted">
                <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" loading="lazy" />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}